import React from 'react';
import './Gallonbottletab.css';



const Gallonbottletab = () => {
    return (
        <div className="mold-container">
            <h2 className="heading">5 Gallon Bottle Caps Injection Molding Production</h2>
            <p><strong>Case for reference:</strong></p>
            <div className="details-grid">
                <div className="left-column">
                    <p><strong>Machine Model</strong> </p>
                    <p><strong>Mold Cavity</strong> </p>
                    <p><strong>Cycle Time</strong> </p>
                    <p><strong>Weight</strong></p>
                    <p><strong>Material</strong></p>
                    <p><strong>Screw</strong></p>
                    <p><strong>Electricity Consumption	</strong></p>

                </div>
                <div className="right-column">
                    <p>Disha KII288-S</p>
                    <p>	12 Cavities</p>           
                    <p>11s</p>
                    <p>	12.1g</p>
                    <p>HDPE</p>
                    <p>	60mm</p>
                    <p>	13.42kWH</p>

                </div>
            </div>
        </div>
    );
};

export default Gallonbottletab;
